import { useEffect, useRef } from 'react';

import {
  buildSplitPingTimeOnPageEventData,
  buildSplitVisitPageEventData,
} from './actionTypes';
import { getUserAttributes } from '../localStorage';

interface Params {
  pageName: string;
  [propertyName: string]: string | number | boolean | null;
}

export const useTrackSplitTimeOnPage = (params: Params) => {
  const { pageName, ...rest } = params;
  const updatedAtRef = useRef(Date.now());

  const handleWindowUnload = () => {
    const timeDiffInSeconds = Math.round(
      (Date.now() - updatedAtRef.current) / 1000,
    );

    const { eventType, value, properties } = buildSplitPingTimeOnPageEventData({
      pageName,
      ping: timeDiffInSeconds,
      ...rest,
    });
    window.splitFactory?.client()?.track('user', eventType, value, properties);
  };

  useEffect(() => {
    window.addEventListener('beforeunload', handleWindowUnload);

    return () => window.removeEventListener('beforeunload', handleWindowUnload);
  }, [pageName]);
};

export const useTrackSplitVisitPage = (params: Params) => {
  const { pageName, ...rest } = params;

  useEffect(() => {
    const { eventType, value, properties } = buildSplitVisitPageEventData({
      pageName,
      ...rest,
    });
    window.splitFactory?.client()?.track('user', eventType, value, properties);
  }, [pageName]);
};

interface UseTrackSplitTimeInModalParams {
  modalName: string;
  isModalOpened?: boolean;
}

export const useTrackSplitTimeInModal = (
  params: UseTrackSplitTimeInModalParams,
) => {
  const { modalName, isModalOpened } = params;

  const openedAtRef = useRef<number | null>(null);

  useEffect(() => {
    if (isModalOpened) {
      openedAtRef.current = Date.now();
    } else if (!!openedAtRef.current) {
      const timeDiffInSeconds = Math.round(
        (Date.now() - openedAtRef.current) / 1000,
      );

      const { isTestUser } = getUserAttributes();

      const { eventType, value, properties } =
        buildSplitPingTimeOnPageEventData({
          pageName: modalName,
          ping: timeDiffInSeconds,
          isTestUser,
        });
      window.splitFactory
        ?.client()
        ?.track('user', eventType, value, properties);
      openedAtRef.current = null;
    }
  }, [modalName, isModalOpened]);
};
